import { TFunction } from 'i18next';

export enum IssueUsageOption {
    IssueUsageStatistic = 'IssueUsageStatistic',
    NotDeliveredYet = 'NotDeliveredYet'
}

export type IssueUsage = IssueUsageStatistic | IssueUsageNotDeliveredYet;

export type IssueUsageNotDeliveredYet = {
    type: IssueUsageOption.NotDeliveredYet;
    label: string;
};
export const issueNotDeliveredYet = (t: TFunction): IssueUsageNotDeliveredYet => ({
    type: IssueUsageOption.NotDeliveredYet,
    label: t('shop.subscriptions.notDeliveredYet')
});

export type IssueUsageStatistic = {
    type: IssueUsageOption.IssueUsageStatistic;
    loans: LoanInfo;
    loansLeft: IssueUsageStatisticLoansLeft;
    usagePercentage?: number;
    reserves?: ReserveInfo;
};

export type LoanInfo = {
    ownLoans: number;
    foreignLoans?: number;
};

export enum LoansLeft {
    LoansLeftZero = 'LoansLeftZero',
    LoansLeftValue = 'LoansLeftValue',
    LoansLeftUnlimited = 'LoansLeftUnlimited'
}

export type IssueUsageStatisticLoansLeft = LoansLeftZero | LoansLeftValue | LoansLeftUnlimited;
export type LoansLeftZero = {
    type: LoansLeft.LoansLeftZero;
};
export type LoansLeftValue = {
    type: LoansLeft.LoansLeftValue;
    loansLeft: number;
};
export type LoansLeftUnlimited = {
    type: LoansLeft.LoansLeftUnlimited;
};

export type ReserveInfo = {
    ownReserves: number;
    foreignReserves?: number;
};
